import { create } from "zustand";

const usePlayer = create<PlayerStoreStateType>()((set, get) => ({
  minDate: 0,
  maxDate: 0,
  timestamp: 0,
  isPlaying: false,
  initialiseTimer: (min: number, max: number) => {
    get().pause();
    set({ timestamp: max, minDate: min, maxDate: max });
  },
  play: () => {
    const { timestamp } = get();
    const currentTimestamp = timestamp > 0 ? timestamp : get().minDate;
    set({ isPlaying: true, timestamp: currentTimestamp });
  },
  pause: () => {
    set({ isPlaying: false });
  },
  replay: () => {
    set({ timestamp: get().minDate, isPlaying: true });
  },
  setTimestamp: (timestamp: number) => {
    set({ timestamp });
  },

  speed: 1,
  setSpeed: (speed: number) => {
    set({ speed });
  },
}));

export default usePlayer;
